import React, { useState } from "react";
import { TabGroup, TabList, Tab } from "@headlessui/react";
import SearchInput from "./searchInput";
import useAccommodationStore from "@/stores/tripBuilder/useAccommodation";
import { IoBed } from "react-icons/io5";
import { HomeIcon } from "@heroicons/react/20/solid";
import { toast } from "@/hooks/use-toast";

interface AccommodationTopBarProps {
  effectiveCheckIn: string;
  isAdmin: boolean;
}

const AccommodationTopBar: React.FC<AccommodationTopBarProps> = ({
  effectiveCheckIn,
  isAdmin,
}) => {
  const { activeAccommodationTab, setActiveAccommodationTab } =
    useAccommodationStore();

  return (
    <section className="w-full">
      <div className="w-full flex flex-row items-center space-x-2">
        <TabGroup
          selectedIndex={
            activeAccommodationTab === "hotels"
              ? 0
              : activeAccommodationTab === "home-stays"
              ? 1
              : 2
          }
          onChange={(index) => {
            if (!isAdmin && index === 2) {
              toast({
                title: "Viewer access restricted",
                description:
                  "Create a copy of this trip to add custom accommodation",
                duration: 3000,
              });
            } else {
              setActiveAccommodationTab(
                index === 0 ? "hotels" : index === 1 ? "home-stays" : "custom"
              );
            }
          }}
          className="w-full"
        >
          <TabList className="flex flex-row w-full space-x-2">
            <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
              <IoBed className="w-4 h-4" />
              <span>Hotels</span>
            </Tab>
            <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
              <HomeIcon className="w-4 h-4" />
              <span>Home Stays</span>
            </Tab>
            <Tab
              className={`rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium ${
                !isAdmin
                  ? "opacity-20"
                  : "text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700"
              } focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out`}
            >
              <i className="fa-solid fa-pen-field"></i>
              <span>Add Custom</span>
            </Tab>
          </TabList>
        </TabGroup>
      </div>
      {/* input */}
      <SearchInput effectiveCheckIn={effectiveCheckIn} />
    </section>
  );
};

export default AccommodationTopBar;
